import { ApiResponsePlaceholderType } from '../types/ApiResponseTypes'
import { DISSECTED_ERROR } from './constants/error-codes'

export enum DissectedErrorGroups {
    RESPONSE_NOT_OK = 'response-ok-false',
    UNEXPECTED_ERROR_PARSING_RESPONSE_OBJECT = 'unexpected-error-parsing-response-object',
    NO_DATA_WHEN_DATA_WAS_EXPECTED = 'expected-data-from-gateway-but-none-arrived-on-nextjs-server',
    IS_SUCCESS_FALSE = 'is-success-false',
    ORIGIN_FRONT_END = 'origin-front-end',
    TYPE_ERROR = 'type-error',
}
export type SuggestedStepsToUser = { en: string[] | string; nl: string[] | string }
export interface DissectedErrorDetails<TApiResponse = ApiResponsePlaceholderType> {
    statusCode?: number
    statusMessage?: string
    callerAction?: string
    errorGroup: DissectedErrorGroups
    suggestedStepsToUser?: SuggestedStepsToUser
    verboseMessage?: string
    apiResponse?: TApiResponse
    cause?: unknown
}

/**
 * is used by dissectResponse, to throw errors with rich context about what went wrong during API response parsing and validation.
 *
 * It is always catched and should never throw to the end user directly.
 *
 * To do something with this error client side, transform it to a HandledApplicationError, which is used in the client to do something meaningful.
 *
 * @see dissectResponse
 * @see defaultDissectedErrorHandler
 * @see HandledApplicationError
 */
export class DissectedError<TApiResponse = ApiResponsePlaceholderType> extends Error {
    statusCode?: number
    statusMessage?: string
    errorGroup: DissectedErrorGroups
    callerAction?: string
    suggestedStepsToUser?: SuggestedStepsToUser
    verboseMessage?: string
    apiResponse?: TApiResponse
    cause?: unknown
    code: string
    constructor(message: string, details: DissectedErrorDetails<TApiResponse>, ...params: ErrorOptions[]) {
        const errorOptions = params?.shift() || {}
        if (!!details.cause) errorOptions.cause = details.cause
        super(message, errorOptions)
        this.statusCode = details.statusCode
        this.statusMessage = details.statusMessage
        this.errorGroup = details.errorGroup
        this.suggestedStepsToUser = details.suggestedStepsToUser
        this.callerAction = details.callerAction
        this.verboseMessage = details.verboseMessage
        this.apiResponse = details.apiResponse
        this.code = DISSECTED_ERROR
        this.message = message
    }
}
